// extracted by mini-css-extract-plugin
module.exports = {"VerifyPage":"VerifyPage_VerifyPage__2eYUh","VerifyPage__spinner":"VerifyPage_VerifyPage__spinner__2XzOH"};